import { DXCC_RAW } from '../data/dxcc.js';
import { PREFIX_ALIAS } from '../data/prefixAlias.js';

const DXCC_DB = DXCC_RAW.map(function(d) {
  return { px: d[0], entity: d[1], cont: d[2], cq: d[3], itu: d[4] };
});
DXCC_DB.sort(function(a, b) { return b.px.length - a.px.length; });

const UNKNOWN = { entity: "Unknown", cont: "??", cq: 0, itu: 0 };

// Um log grande repete muito indicativo (26.721 distintos em 158.174 QSOs) e a
// busca varre a tabela inteira a cada chamada. Memoizar corta a conversao do log
// em ~4x. O resultado ja era um objeto compartilhado do DXCC_DB, entao o cache
// nao muda o contrato - continua sendo somente leitura.
const CACHE = new Map();

export function lookupDXCC(callsign) {
  if (!callsign) return UNKNOWN;
  const hit = CACHE.get(callsign);
  if (hit !== undefined) return hit;
  const rec = resolveDXCC(callsign);
  CACHE.set(callsign, rec);
  return rec;
}

function resolveDXCC(callsign) {
  var cs = callsign.toUpperCase().replace(/[^A-Z0-9/]/g, "");
  var parts = cs.split("/");
  var mainCall = parts[0];
  for (var i = 0; i < parts.length; i++) {
    if (parts[i].length > mainCall.length) mainCall = parts[i];
  }
  // Try each part against DXCC DB directly
  for (var i = 0; i < parts.length; i++) {
    for (var j = 0; j < DXCC_DB.length; j++) {
      if (parts[i] === DXCC_DB[j].px || parts[i].startsWith(DXCC_DB[j].px)) return DXCC_DB[j];
    }
  }
  // Try prefix alias map
  for (var len = Math.min(mainCall.length, 5); len >= 1; len--) {
    var tryPx = mainCall.substring(0, len);
    var mapped = PREFIX_ALIAS[tryPx];
    if (mapped) {
      var found = DXCC_DB.find(function(d) { return d.px === mapped; });
      if (found) return found;
    }
  }
  // Try direct match
  for (var len = Math.min(mainCall.length, 5); len >= 1; len--) {
    var tryPx = mainCall.substring(0, len);
    var found = DXCC_DB.find(function(d) { return d.px === tryPx; });
    if (found) return found;
  }
  return UNKNOWN;
}
